import Form from "../form";
import FormBuilderSortable from "../../../form_builder/models/formBuilderSortable";

export default class FormDetailStep extends FormBuilderSortable {
  type: number;
  title: string;
  description: string;

  constructor(form: Form) {
    super();
    this.rootModel = form;
    this.parent = form;
  }

  get rootName() {
    return "form_detail_step";
  }

  get displayName() {
    return "Form Detail Step";
  }
}
